import * as turf from '@turf/turf'
import { GeoJSON } from 'ol/format';
import { Polygon,MultiPolygon } from 'ol/geom';
const format = new GeoJSON();
const TurfUtil = {
  booleanPointInPolygon(pt,features){
    const point = turf.point(pt)
    let isIn = false
    features.forEach(feature => {
      const geom = feature.getGeometry()
      const polygon = this.getFeature(geom)
      if (polygon) {
        const result = turf.booleanPointInPolygon(point, polygon)
        result && (isIn=true)
      }
    });
    return isIn
  },
  area(geom){
    const polygon = this.getFeature(geom)
    return polygon?turf.area(polygon):0
  },
  mask(polygon1, polygon2){
    const polygon = this.getFeature(polygon1)
    const mask = this.getFeature(polygon2)
    const diff = turf.difference(polygon,mask);
    return diff ?format.readGeometry(diff.geometry) : null;
  },
  intersect(polygon1,polygon2){
    const p1 = this.getFeature(polygon1)
    const p2 = this.getFeature(polygon2)
    const intersect = turf.intersect(p1,p2)
    const geometry = new Polygon( [intersect.geometry.coordinates[0]])
    return geometry;
  },
  getFeature(geometry){
    let feature = null
    if (geometry instanceof Polygon) {
      feature = turf.polygon(geometry.getCoordinates())
    }else if(geometry instanceof MultiPolygon){
      feature = turf.multiPolygon(geometry.getCoordinates())
    }
    return feature
  },
  buffer(coordinates,type,distance,props={units: 'kilometers'}){
    let geometry = null

    if (type==='Point') {
      geometry = turf.point(coordinates)
    }else if(type==='Polyline'){
      geometry = turf.lineString(coordinates)
    }else if(type==='Polygon'){
      geometry = turf.polygon(coordinates)
    }
    
    const buff = turf.buffer(geometry, distance,props );
    return buff.geometry.coordinates
  },
  splitPolygonByLine(polygon, splitLine, tolerance = 0.000001, toleranceType = 'kilometers') {
    const line = turf.lineString(splitLine.getCoordinates())
    const poly = polygon instanceof Polygon? turf.polygon(polygon.getCoordinates()) : turf.multiPolygon(polygon.getCoordinates())
    // 1. 条件判断
    if (poly.geometry === void 0 ) {
      throw '传入的必须为polygon、multiPolygon'
    }
    if (line.geometry === void 0 || line.geometry.type.toLowerCase().indexOf('linestring') === -1) {
      throw '传入的必须为linestring'
    }

    if (line.geometry.type === 'LineString') {
      if (
        turf.booleanPointInPolygon(turf.point(line.geometry.coordinates[0]), poly) ||
        turf.booleanPointInPolygon(turf.point(line.geometry.coordinates[line.geometry.coordinates.length - 1]), poly)
      ) {
        throw '起点和终点必须在多边形之外'
      }
    }
    // 2. 计算交点，并把线的点合并
    //计算相交点
    let lineIntersect = turf.lineIntersect(line, poly)
    //获取一个或一组Feature，并将所有位置作为点返回。拆分为点
    const lineExp = turf.explode(line)

    for (let i = 0; i < lineExp.features.length - 1; i++) {
      lineIntersect.features.push(turf.point(lineExp.features[i].geometry.coordinates))
    }
    // 3. 计算线的缓冲区
    const lineBuffer = turf.buffer(line, tolerance, {
      units: toleranceType,
    })
    // 4. 计算线缓冲和多边形的difference，返回"MultiPolygon"，所以将其拆开
    //通过从第一个多边形剪裁第二个多边形来查找两个多边形之间的差异。
    const _body = turf.difference(poly, lineBuffer)
    let pieces = []
    if (_body.geometry.type === 'Polygon') {
      pieces.push(turf.polygon(_body.geometry.coordinates))
    } else {
      _body.geometry.coordinates.forEach(function (a) {
        pieces.push(turf.polygon(a))
      })
    }
    // 5. 处理点数据
    for (let p = 0; p < pieces.length; p++) {
      const piece = pieces[p]
      for (let c in piece.geometry.coordinates[0]) {
        const coord = piece.geometry.coordinates[0][c]
        const p = turf.point(coord)
        for (let lp in lineIntersect.features) {
          const lpoint = lineIntersect.features[lp]
          //判断两点距离
          if (turf.distance(lpoint, p, toleranceType) <= tolerance * 2) {
            piece.geometry.coordinates[0][c] = lpoint.geometry.coordinates
          }
        }
      }
    }
    // 6. 过滤掉重复点
    // for (let p=0;p<pieces.length; p++) {
    //   const coords = pieces[p].geometry.coordinates[0];
    //   pieces[p].geometry.coordinates[0] = filterDuplicatePoints(coords);
    // }
    // 7. 将属性赋予每一个polygon，并处理id
    pieces.forEach((a, index) => {
      a.properties = Object.assign({}, poly.properties)
      a.properties.id += `-${index}`
    })

    //获取一个或多个Feature并创建一个FeatureCollection。
    return turf.featureCollection(pieces)
  },
}
export default TurfUtil;